import { TeamsCustomizations } from '@uifabric/theme-samples';
import { Theme } from '@fluentui/theme';

export const TeamsTheme: Theme = TeamsCustomizations.settings.theme;
